const ROOT_KEY = '@root';
const FALLBACK_KEY = '@any';
const EXTENDS_KEY = '@extends';

module.exports = {
  ROOT_KEY,
  FALLBACK_KEY,
  EXTENDS_KEY,
};
